import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const fetchTransportationCost = async (params = {}) => {
  try {
    const qs = reqTransform.fetchTransportationCost(params);
    const url = `${baseUrl}/BioFuelRequirementOffers/api/Bid/FetchTransportationCost_ELOC?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchTransportationCost(resData);
  } catch (err) {
    console.log('api-farms-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'FetchTransportationCost_ELOC');
    throw errors;
  }
};
